import { render, staticRenderFns } from "./ConnectWalletOption.vue?vue&type=template&id=55cfe7a6&scoped=true"
import script from "./ConnectWalletOption.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletOption.vue?vue&type=script&lang=ts"
import style0 from "./ConnectWalletOption.vue?vue&type=style&index=0&id=55cfe7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cfe7a6",
  null
  
)

export default component.exports